// extracted by mini-css-extract-plugin
export default {"about":"About_about__VYW1e","about_title":"About_about_title__aWVhd","about_text":"About_about_text__tqhys","about_bg":"About_about_bg__31soD"};